import PropTypes from 'prop-types';

import { getRoom, roomPropTypes, checkDistributionPaxes } from './Room.model';

import { STATUS_CANCELED, PMS_RESERV_TYPE } from '../commons/utils';
import { getActualDate, addNdays, isBeforeDate } from '../commons/datesUtils';

const currentDate = getActualDate(true);

const checkIfItsReadOnly = (fromDate, status, reservationType) => {
  if (reservationType === PMS_RESERV_TYPE) return true;

  if (!fromDate) return true;

  if (status === STATUS_CANCELED) return true;

  if (isBeforeDate(fromDate, currentDate, 'DD/MM/YYYY')) return true;

  return false;
};

const getReservation = (index = 1) => ({
  id: index,
  hotel: '',
  status: '',
  locator: '',
  fromDate: currentDate,
  toDate: addNdays(currentDate, 1, true),
  amount: 0,
  rawAmount: 0,
  currencyCode: '',
  rooms: [getRoom()],
  comment: '',
  readOnly: false
});

const reservationPropTypes = {
  id: PropTypes.number,
  hotel: PropTypes.string,
  status: PropTypes.string,
  locator: PropTypes.string,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  bookingDate: PropTypes.string,
  amount: PropTypes.number,
  rawAmount: PropTypes.number,
  currencyCode: PropTypes.string,
  rooms: PropTypes.arrayOf(roomPropTypes),
  comment: PropTypes.string
};

const mapStateGlobal = (state) => ({
  userDefaultLang: state.session.userDefaultLang
});

const mapDispatchGlobal =  dispatch => ({
  handleReservationBackUp: (reservationId, reservationType) => {
    dispatch({
      type: 'UNDO_RESERVATION_CAHNGES',
      id: reservationId,
      reservationType
    })
  },
  handleReservationElimination: (reservationId) => {
    dispatch({
      type: 'ERASE_RESERVATION_FROM_LIST',
      id: reservationId
    })
  },
  handleReservationViewMode: (reservationId) => {
    dispatch({
      type: 'TOGGLE_RESERVATION_VIEW_MODE',
      id: reservationId
    })
  },
  handleReservationDates: (reservationId, fromDate, toDate) => {
    dispatch({
      type: 'UPDATE_RESERVATION_DATES',
      id: reservationId,
      fromDate,
      toDate
    })
  },
  handleReservationComment: (reservationId, comment) => {
    dispatch({
      type: 'UPDATE_RESERVATION_COMMENT',
      id: reservationId,
      comment
    })
  },
  handleReservationNewRoom: (reservationId) => {
    dispatch({
      type: 'ADD_RESERVATION_NEW_ROOM',
      id: reservationId
    })
  },
  handleReservationRemoveRoom: (reservationId, roomId) => {
    dispatch({
      type: 'ERASE_RESEREVATION_ROOM',
      id: reservationId,
      roomId
    })
  },
  handleReservationRoomType: (reservationId, roomId, roomCode) => {
    dispatch({
      type: 'UPDATE_RESERVATION_ROOM_CODE',
      id: reservationId,
      roomId,
      roomCode
    })
  },
  handleReservationRoomMealPlan: (reservationId, roomId, mealPlan) => {
    dispatch({
      type: 'UPDATE_RESERVATION_ROOM_MEAL_PLAN',
      id: reservationId,
      roomId,
      mealPlan
    })
  },
  handleReservationRoomDistribution: (reservationId, roomId, distributionData) => {
    dispatch({
      type: 'UPDATE_RESERVATION_ROOM_DISTRIBUTION',
      id: reservationId,
      roomId,
      distributionData
    })
  },
  handleReservationPaxData: (reservationId, roomId, paxData) => {
    dispatch({
      type: 'UPDATE_RESERVATION_PAX_DATA',
      id: reservationId,
      roomId,
      paxData
    })
  },
  handleReservationsPaxList: (reservationId, roomId, desiredNumber) => {
    dispatch({
      type: 'UPDATE_RESERVATION_PAX_LIST',
      id: reservationId,
      roomId,
      desiredNumber
    })
  }
});

function extendReservationData(reservation, extendedData) {
  const { fromDate, status, reservationType } = reservation;

  const {
    bookingDate,
    rawAmount,
    comment,
    rooms,
    block
  } = extendedData;

  const reservationRooms = (rooms) ? rooms : [getRoom()];

  return {
    ...reservation,
    bookingDate,
    rawAmount: (rawAmount) ? rawAmount : 0,
    comment: (comment) ? comment : '',
    readOnly: checkIfItsReadOnly(fromDate, status, reservationType),
    rooms: reservationRooms.map((room, index) => {
      const { distribution, paxes } = room;
      const paxesList = checkDistributionPaxes(distribution, paxes);

      return {
        id: (index +1),
        ...room,
        paxes: paxesList.map((pax, index) => {
          return {
            id: (index +1),
            ...pax
          }
        })
      };
    }),
    groupId: (block?.id) ? block.id : 0
  };
}

function revertReservationData(reservation, backUpData) {
  const {
    fromDate,
    toDate,
    amount,
    rawAmount,
    rooms,
    comment
  } = backUpData;

  return {
    ...reservation,
    fromDate,
    toDate,
    amount,
    rawAmount,
    rooms,
    comment
  };
}

export {
  getReservation,
  reservationPropTypes,
  mapStateGlobal,
  mapDispatchGlobal,
  checkIfItsReadOnly,
  extendReservationData,
  revertReservationData
};
